import { inrMajorToDisplay, parseCurrencyType } from '@/lib/currency'
import { tickerAmt } from '@/lib/format'
import { isLineSessionBetListMarket } from '@/features/net-exposure/workstation/lineSessionBetOdds'

/**
 * Workstation bet-list Matched / Unmatched (stake columns).
 *
 * POINTS / POINT@1 → display points (₹100 → 1), including Betfair Line Session.
 * Book / NE tree stays INR via `lineSessionMoneyOpts` — do not change that here.
 * INR stakes unchanged.
 */
export function betListMatchedUnmatchedAmt(
  amount: number | null | undefined,
  currencyType: string | undefined,
  _marketName?: string | null,
): string {
  void _marketName
  const ccy = parseCurrencyType(currencyType)
  if (ccy === 'INR') return tickerAmt(amount)
  if (amount == null || typeof amount !== 'number' || !Number.isFinite(amount) || amount === 0) {
    return tickerAmt(amount)
  }
  return tickerAmt(inrMajorToDisplay(amount, ccy))
}

/** P&L cell currency: Lab INR majors on line session only (book-side INR). */
export function betListProfitLiabilityCurrency(
  currencyType: string | undefined,
  marketName?: string | null,
): string {
  if (isLineSessionBetListMarket(marketName)) return 'INR'
  return currencyType || 'INR'
}
